import { Box } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";

const MembersHomepage = () => {
	return (
		<Box>
			<Outlet />
		</Box>
	);
};

export default MembersHomepage;
